import gql from 'graphql-tag';

export default gql`
  query GetAllFacilities($statusFilter: FacilityStatus, $searchTerm: String) {
    facilities(
      orderBy: name_ASC
      where: { status: $statusFilter, OR: [{ name_contains: $searchTerm }, { description_contains: $searchTerm }] }
    ) {
      id
      name
      status
      description
      logo
      email
      telephoneNumber
      whatsappNumber
      mondayHours
      tuesdayHours
      wednesdayHours
      thursdayHours
      fridayHours
      saturdayHours
      sundayHours
      tradingHours
      menus
      pdfs
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/queries/GetAllFacilities.ts